import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class SlideBinding implements ICustomBinding {

    private static slideCallback(callback, element) {
        if (callback) {
            callback($(element));
        }
    }

    public initBinding() {
        ko.bindingHandlers.slide = {
            init: (element, valueAccessor) => {
                let params = ko.unwrap(valueAccessor());
                let value = ko.unwrap(params.value);

                $(element).toggle(value);
            },
            update: (element, valueAccessor) => {
                let params = ko.unwrap(valueAccessor());
                let value = ko.unwrap(params.value);

                value ? $(element).slideDown(120, () => {
                    SlideBinding.slideCallback(params.onSlideDown, element);
                }) : $(element).slideUp(120, () => {
                    SlideBinding.slideCallback(params.onSlideUp, element);
                });
            }
        };
    }
}